/* eslint-disable max-len */
import React, { Component } from 'react';
import { find } from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import PropTypes, { any } from 'prop-types';

import Img from '../../Img';
import { Utr, UtrLabel } from '../../text';
import Description from '../../text/Description';
import withAuth from '../../hocs/withAuth';
import BackgroundImage from '../../BackgroundImage';
import Stats from '../TeamStandingsCard/Stats';
import { dictFromArrayByProp } from '../../../utils';
import { titleCase } from '../../../utils/formatting';
import { sportTypeIds } from '../../../utils/eventConstants';
import PickleBallRating from '../PlayerCard/SharedComponents/PickleBallRating';

const _ = { find };

class PlayerStandingsCard extends Component {
    render() {
        const {
            rank,
            player,
            currentDivision,
            showPlayerStatus,
            utrType,
            showSeeProfileLink,
            showDecimals,
            auth,
            showRatingNotLoggedIn,
            displayCollegeRecruitingValues,
            hideRatings,
            stats,
            sportTypeId,
            drawMedal,
            divisionMedals,
            'data-testid': dataTestId,
        } = this.props;

        if (!this.props.player) {
            return null;
        }

        const {
            id,
            gender,
            location,
            ratingStatusSingles,
            nationality,
            playerProfileImages,
            playerCollege,
            playerCollegeDetails,
            playerHighSchool,
            playerHighSchoolDetails,
            age,
            descriptionShort,
            studentInfo,
        } = player || {};

        const firstName = titleCase(player.firstName);
        const lastName = titleCase(player.lastName);

        const userLoggedIn = auth?.user;
        const isPickleBallSportType = sportTypeId === sportTypeIds.PICKLEBALL;

        const nationalFlag = nationality ? `/img/flags/${nationality.toLowerCase()}.svg` : '';
        const playerDIvision = _.find(player.registeredDivisions, { divisionId: currentDivision });

        let descriptionMobile = '';
        if (descriptionShort) {
            descriptionMobile = [descriptionShort];
        } else {
            descriptionMobile = location?.display ? [location.display] : [];
        }

        let collegeRecruitingHighSchoolGradYear = null;

        if (studentInfo?.graduationDate) {
            collegeRecruitingHighSchoolGradYear = studentInfo.graduationDate;
        } else if (playerHighSchoolDetails?.gradYear) {
            collegeRecruitingHighSchoolGradYear = playerHighSchoolDetails.gradYear;
        }

        const descriptionItemsMobile = [
            ...(gender ? [gender.charAt(0)] : []),
            ...(displayCollegeRecruitingValues && age ? [`Age ${age}`] : []),
            ...(displayCollegeRecruitingValues && collegeRecruitingHighSchoolGradYear ? [`Grad. ${moment(collegeRecruitingHighSchoolGradYear).year().toString()}`] : []),
            ...(descriptionMobile),
        ];

        let clubCollegeDetailsMobile;

        if (playerCollege?.shortName) {
            if (playerCollegeDetails?.gradYear) {
                if (moment().diff(moment(playerCollegeDetails.gradYear)) < 0) {
                    clubCollegeDetailsMobile = `${gender.charAt(0)} \u2022 ${playerCollege.shortName} ('${moment(playerCollegeDetails.gradYear).format('YY')})`;
                }
            }
        }
        if (playerHighSchool?.shortName) {
            if (playerHighSchoolDetails?.gradYear) {
                // if player is currently in high school, show on mobile cards instead of location
                if (!clubCollegeDetailsMobile && moment().diff(moment(playerHighSchoolDetails.gradYear)) < 0) {
                    let playerAgeAndStudentInfoGradYearString = '';

                    if (displayCollegeRecruitingValues) {
                        if (age) {
                            playerAgeAndStudentInfoGradYearString += `Age ${age} \u2022 `;
                        }
                        if (studentInfo?.graduationDate) {
                            playerAgeAndStudentInfoGradYearString += `Graduating ${moment(studentInfo.graduationDate).year().toString()} \u2022 `;
                        } else {
                            playerAgeAndStudentInfoGradYearString += `Graduating ${moment(playerHighSchoolDetails.gradYear).year().toString()} \u2022 `;
                        }
                    }

                    clubCollegeDetailsMobile = `${gender.charAt(0)} \u2022 ${playerAgeAndStudentInfoGradYearString}${playerHighSchool.shortName} ('${moment(playerHighSchoolDetails.gradYear).format('YY')})`;
                }
            }
        }

        const statsObj = stats ? dictFromArrayByProp(stats, 'type') : {};
        console.log('statsObj', statsObj);

        const renderLinkIf = (content, condition, Id) => {
            if (condition && Id) {
                const href = `/profiles/${Id}`;
                return (<Link to={href} data-testid={dataTestId && `${dataTestId}.card-link`}>{content}</Link>);
            }
            return (content);
        };

        const showRatings = userLoggedIn || showRatingNotLoggedIn;

        return renderLinkIf(
            <div className={`utr-card player-card`}>
                <div className={`list-view d-none d-md-block`}>
                    <div className="d-flex">
                        <div className="flex-grow">
                            <div className="row">
                                <div className="col-1 d-flex justify-content-center">
                                    {drawMedal && drawMedal < 4 && <Img src={`/img/medals/${drawMedal}.svg`} style={{ width: '100%' }} />}
                                </div>
                                <div className={`col-md-4`}>
                                    {!!rank && <div className="rank" data-testid={dataTestId && `${dataTestId}.desktop.rank`}>{rank}</div>}
                                    <div className="avatar-wrapper">
                                        <BackgroundImage
                                            baseUrl={'/v1/player/'}
                                            defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                            images={playerProfileImages}
                                            imageType={'icon'}
                                            parentStylesClass={'avatar d-inline-block'}
                                        />
                                        {nationalFlag && <Img className="flag" src={nationalFlag} alt={nationality} />}
                                    </div>
                                    <div className="name-and-place show-ellipsis">
                                        <div className="name show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.name`}>{firstName} {lastName}</div>
                                        {divisionMedals && divisionMedals.length > 0 &&
                                            divisionMedals.map((divisionMedal, i) => {
                                                return (
                                                    <div key={i} className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.place-${i}`}>
                                                        <Img src={`/img/medals/${divisionMedal.medal}.svg`} />
                                                        {divisionMedal.divisionName}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                                <div className={`col-md-7`}>
                                    <div className="row w-100">
                                        {!hideRatings && (
                                            <div className={`col text-center`}>
                                                {showRatings && !isPickleBallSportType && (
                                                    <React.Fragment>
                                                        <div className="values" data-testid={dataTestId && `${dataTestId}.desktop.singles-values`}>
                                                            <div
                                                                className={`value ${utrType === 'sanctioned' && ratingStatusSingles !== 'Rated' ? 'text-lighter' : ''}`}
                                                                title={utrType === 'sanctioned' ? ratingStatusSingles : ''}
                                                                data-testid={dataTestId && `${dataTestId}.desktop.singles-utr`}
                                                            >
                                                                <Utr player={player} force={{ ratingType: 'singles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.desktop.singles-utr`} />
                                                            </div>
                                                            <div className="title" data-testid={dataTestId && `${dataTestId}.desktop.singles-label`}>
                                                                <UtrLabel player={player} force={{ ratingType: 'singles', utrType, typeDots: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.desktop.singles-label`} />
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                                {showRatings && isPickleBallSportType && (
                                                    <PickleBallRating player={player} ratingType={'singles'} data-testid={dataTestId && `${dataTestId}.desktop.singles-pickleball`} />
                                                )}
                                            </div>
                                        )}
                                        {stats && (
                                            <Stats
                                                stats={stats}
                                                data-testid={dataTestId && `${dataTestId}.desktop.stats`}
                                            />
                                        )}
                                        {!stats && (
                                            <>
                                                <div className="col" />
                                                <div className="col" />
                                                <div className="col" />
                                                <div className="col" />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`card-view d-block d-md-none`}>
                    <div className="row">
                        {showPlayerStatus && (
                            <React.Fragment>
                                <div className={`badge registration-status text-small`} data-testid={dataTestId && `${dataTestId}.mobile.registration-status`}>{playerDIvision.registrationStatus}</div>
                                <div className={`badge payment-status text-small`} data-testid={dataTestId && `${dataTestId}.mobile.payment-status`}>{playerDIvision.paymentStatus}</div>
                            </React.Fragment>
                        )}
                        <div className="col-8">
                            <div className="name-and-place show-ellipsis">
                                <div className="name h6 show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.name`}>{!!rank && <span className="rank" data-testid={dataTestId && `${dataTestId}.mobile.rank`}>{rank}.&nbsp;</span>}{firstName} {lastName}</div>
                                <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.place`}>
                                    <Description desc={clubCollegeDetailsMobile || descriptionItemsMobile} data-testid={dataTestId && `${dataTestId}.mobile.place`} />
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="avatar-container ml-auto">
                                <BackgroundImage
                                    baseUrl={'/v1/player/'}
                                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                    images={playerProfileImages}
                                    imageType={'icon'}
                                    parentStylesClass={'avatar'}
                                />
                                {nationality && (
                                    <div className="flag-container">
                                        <Img
                                            className="flag"
                                            src={nationalFlag}
                                            alt={nationality}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row profile-details">
                        {!hideRatings && (
                            <React.Fragment>
                                <div className="col-4">
                                    {showRatings && !isPickleBallSportType && (
                                        <div className="values" data-testid={dataTestId && `${dataTestId}.mobile.singles-values`}>
                                            <div className="title" data-testid={dataTestId && `${dataTestId}.mobile.singles-label`}>
                                                <UtrLabel player={player} force={{ ratingType: 'singles', utrType, typeDots: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.singles-label`} />
                                            </div>
                                            <div
                                                className={`value ${utrType === 'sanctioned' && ratingStatusSingles !== 'Rated' ? 'text-lighter' : ''}`}
                                                title={utrType === 'sanctioned' && ratingStatusSingles !== 'Rated' ? ratingStatusSingles : ''}
                                                data-testid={dataTestId && `${dataTestId}.mobile.singles-utr`}
                                            >
                                                <Utr player={player} force={{ ratingType: 'singles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.singles-utr`} />
                                            </div>
                                        </div>
                                    )}
                                    {showRatings && isPickleBallSportType && (
                                        <PickleBallRating player={player} ratingType={'singles'} data-testid={dataTestId && `${dataTestId}.mobile.singles-pickleball`} />
                                    )}
                                    {!showRatings && (
                                        <div className="values" data-testid={dataTestId && `${dataTestId}.mobile.singles-values-empty`}>&nbsp;</div>
                                    )}
                                </div>
                                {stats && (
                                    <Stats
                                        stats={stats}
                                        force={{ cardView: true }}
                                        dividerIndex={2}
                                        data-testid={dataTestId && `${dataTestId}.mobile.stats`}
                                    />
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>,
            !showSeeProfileLink,
            id,

        );
    }
}

PlayerStandingsCard.propTypes = {
    rank: PropTypes.number,
    player: PropTypes.objectOf(any).isRequired,
    currentDivision: PropTypes.objectOf(any).isRequired,
    showPlayerStatus: PropTypes.bool,
    utrType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    showSeeProfileLink: PropTypes.bool,
    showDecimals: PropTypes.bool,
    auth: PropTypes.objectOf(any).isRequired,
    showRatingNotLoggedIn: PropTypes.bool,
    displayCollegeRecruitingValues: PropTypes.bool,
    hideRatings: PropTypes.bool,
    stats: PropTypes.arrayOf(any),
    sportTypeId: PropTypes.number,
    drawMedal: PropTypes.number,
    divisionMedals: PropTypes.arrayOf(any),
    'data-testid': PropTypes.string,
};

PlayerStandingsCard.defaultProps = {
    rank: null,
    'data-testid': null,
    showPlayerStatus: false,
    utrType: null,
    showSeeProfileLink: false,
    showDecimals: false,
    showRatingNotLoggedIn: false,
    displayCollegeRecruitingValues: false,
    hideRatings: false,
    stats: [],
    sportTypeId: sportTypeIds.TENNIS,
    drawMedal: null,
    divisionMedals: [],
};

export default withAuth(PlayerStandingsCard);
